module.exports = __webpack_public_path__ + "img/non-fill.278404d3.png";